import { ProductVisibilityType } from "@omni/types/api/product/bff/shared/enums/productVisibilityType.enum";
import { ProductVariant } from "@omni/types/api/product/bff/shared/variants.model";
import { cn } from "@omni/utils/styles";

type Props = {
    variantGroup: ProductVariant[];
    sku: string;
};

const Swatches = ({ variantGroup, sku }: Props) => {
    return (
        <>
            {variantGroup
                .filter(
                    (variant) =>
                        variant.productVisibilityType !==
                        ProductVisibilityType.NotAvailable
                )
                .map((variant) => (
                    <div
                        key={variant.sku}
                        className={cn("tw:flex tw:flex-row tw:flex-wrap")}
                    >
                        <a
                            title={variant.productTitle}
                            href={variant.url}
                            className={cn(
                                "tw:w-8 tw:h-8 tw:border tw:border-grey-input tw:relative tw:hover:cursor-pointer",
                                sku === variant.sku
                                    ? "tw:border-2 tw:border-primary tw:font-bold"
                                    : "",
                                "tw:flex tw:justify-center tw:items-center tw:m-1"
                            )}
                        >
                            {variant.productVisibilityType ===
                                ProductVisibilityType.TemporaryNotAvailable && (
                                <div
                                    className={cn(
                                        "tw:w-full tw:h-full tw:absolute",
                                        "tw:bg-repeat",
                                        "tw:bg-[url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAKElEQVQYV2NkQAP9/f3/GZHFQAKFhYWMcEGYAEgRWBBZACyILgASBACTBxKyRBa+6AAAAABJRU5ErkJggg==)]"
                                    )}
                                />
                            )}
                            {variant.thumbnailUrl && (
                                <img
                                    className={cn("tw:w-full tw:p-0.5")}
                                    src={variant.thumbnailUrl}
                                    alt={variant.productTitle}
                                />
                            )}
                        </a>
                    </div>
                ))}
        </>
    );
};

export default Swatches;
